import React, { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchContent } from "@/lib/api";

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const { data } = useQuery({ queryKey: ["content"], queryFn: fetchContent, staleTime: 60000 });
  return <ContentContext.Provider value={data || null}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
